import React from 'react';
import ConfirmDialog from './ConfirmDialog';

/**
 * Modernized confirmModal preserving exact prop signature for 100% backward compatibility.
 */
const ConfirmModal = ({
  title,
  ConfirmText,
  confirmText,
  description,
  error,
  hideModal,
  onClose,
  handleConfirmation,
  onConfirm,
  loading = false,
  variant = 'danger',
}) => {
  return (
    <ConfirmDialog
      isOpen={true}
      title={title}
      description={description}
      error={error}
      confirmText={ConfirmText || confirmText || 'Confirm'}
      onConfirm={handleConfirmation || onConfirm}
      onClose={hideModal || onClose}
      loading={loading}
      variant={variant}
    />
  );
};

export default ConfirmModal;
